module.exports = "./assets/fonts/Whisper.woff";